import React from "react";
import HelpModal from "common/HelpModal.jsx";

const ThroughputLiveHelpModal = () => (
    <HelpModal
      title="Subscriber Throughput"
      content={() => (
        <>
          <p>
            This page shows the throughput in real time of the twenty
            subscribers with the biggest traffic usage, plus the throughput of
            the remaining subscribers (rest category). It can also show charts
            with the real-time latency and retransmissions.
            You can chose to see the downlink traffic + latency + 
            retransissions, the uplink traffic + latency + retransissions,
            or the downlink + uplink traffic.
          </p>
          <p>
            To stop the real time update of the charts, disable the Live mode
            switch.
          </p>
          <p>
            There is a table showing the Current Speed (Mbps),
            Average Speed (Mbps), Latency (ms), and Retransmissions (%). In
            this table, if you click on the IP addresses  or subscriber-Ids,
            you will go to their respective dashboard. If you click on the
            tick boxes in the PLOT column, and the latency/retransmissions
            chart is shown, you will be able to see the corresponding
            latency/retransmission for that IP Address/subscriber-ID.
          </p>
          <p>
            Subscribers can be labeled by their IP addresses (IP-Addr) or by
            their identifiers (Subs-Ids). The live mode will show by default up
            to 2 minutes (2 min. time span). Choices of 5 and 10 minutes are
            also available. It is also possible to select no time-out, which
            means that the charts will be shown until manually stopped.
          </p>
          <p>
            Placing the mouse over a chart will show a tootip with the current
            throughput of the subscribers and a total and average throughput at
            the bottom. The total throughput is the sum of the throughput of all 
            subscribers, not just of the ones in the table. The average throughput 
            is calculated since the live mode started.
          </p>
        </>
      )}
    />
  );
export default ThroughputLiveHelpModal;
